export const useSxStyles = () => {
  return {
    table: {
      marginTop: '20px',
      marginBottom: '20px',
    },
    tr: {
      display: 'block',
      float: 'left',
      marginRight: '10px',
    },
    tr2: {
      display: 'block',
      float: 'left',
      marginRight: '10px',
      maxWidth: '400px',
      marginLeft: '50px',
    },
    td: {
      display: 'block',
      padding: '5px',
    },
    tdProgress: {
      display: 'block',
      borderBottom: '1px solid black',
      paddingLeft: '4px',
    },
    tableDiv: {
      paddingTop: '4px',
    },
    leftDiv: {
      display: 'table-cell',
      width: '150px',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    midDiv: {
      display: 'table-cell',
      maxWidth: '70px',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    rightDiv: {
      display: 'table-cell',
      textAlign: 'right',
      width: '30px',
      fontSize: '13px',
    },
    label: {
      gridArea: 'label',
      fontSize: '13px',
      fontWeight: 'bold',
      lineHeight: '19px',
      alignSelf: 'start',
      '&::after': {
        content: '":"',
      },
    },
    value: {
      gridArea: 'value',
      fontSize: '14px',
    },
    actionDiv: {
      float: 'right',
    },
    button: {
      float: 'right',
      marginRight: '8px',
    },
    table2: {
      borderCollapse: 'collapse',
      cellSpacing: '0px',
      '& thead': {
        '& th': {
          padding: 0,
          textAlign: 'left',
          fontSize: '13px',
          fontWeight: 'bold',
          paddingRight: '15px',
        },
      },
      '& tbody': {
        '& td': {
          textAlign: 'left',
          fontSize: '13px',
          paddingRight: '15px',
        },
      },
    },
    td2: {
      textAlign: 'left',
      fontSize: '13px',
    },
    abc: {
      background: 'red',
    },
    label1: {
      fontWeight: 'bold',
      fontSize: '13px',
      minWidth: '130px',
      width: '130px',
      paddingLeft: '12px',
    },
    editLabel1: {
      fontWeight: 'bold',
      fontSize: '13px',
      minWidth: '150px',
      width: '150px',
      paddingLeft: '4px',
    },
    label2: {
      fontWeight: 'bold',
      fontSize: '13px',
      minWidth: '100px',
      width: '130px',
      paddingRight: '1px',
    },
    label3: {
      fontSize: '13px',
      minWidth: '30px',
      width: '30px',
      textAlign: 'right',
      paddingRight: '40px',
      marginRight: '40px',
    },
    input: {
      width: '40px',
      padding: '3px 6px',
      fontSize: '14px',
      borderRadius: '4px',
      border: '1px solid #ccc',
    },
  };
};
